import React from 'react';

export default function TelegramIcon({ width, height, fill }) {
	return (
		<svg
			width={width ? width : '19'}
			height={height ? height : '20'}
			viewBox='0 0 19 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M9.5 0.671875C14.584 0.671875 18.7031 4.79102 18.7031 9.875C18.7031 14.959 14.584 19.0781 9.5 19.0781C4.41602 19.0781 0.296875 14.959 0.296875 9.875C0.296875 4.79102 4.41602 0.671875 9.5 0.671875ZM13.9902 6.98047C14.1387 6.38672 13.7676 6.12695 13.3594 6.27539L4.49023 9.68945C3.89648 9.91211 3.89648 10.2832 4.37891 10.4316L6.64258 11.1367L11.9121 7.79688C12.1719 7.64844 12.3945 7.75977 12.209 7.9082L7.94141 11.7676L7.79297 14.1055C8.01562 14.1055 8.12695 13.9941 8.23828 13.8828L9.35156 12.8066L11.6523 14.5137C12.0977 14.7363 12.3945 14.625 12.5059 14.1055L13.9902 6.98047Z'
				fill={fill ? fill : '#3E8FCB'}
			/>
		</svg>
	);
}
